/**
 * Where a person actually buys a plan.
 *
 * Payment is IN THE APPS: Play Billing and StoreKit are in-app only, so the
 * web funnel shows what the plans cost and points here (spec 2026-09-07 §10).
 * A browser cannot complete a store purchase at all, which is why the plan
 * step no longer has a Continue-to-checkout button.
 */

export const APP_STORE_URL = 'https://apps.apple.com/app/imageshield/id0000000000';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.imageshield.imageshieldmobileapp';
